import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useAdSenseRefresh() {
  const location = useLocation();

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }, [location.pathname]);
}
